<div class="md:hidden">
    <div class="relative w-20 h-20">
        <svg class="w-full h-full" viewBox="0 0 100 100">
            <circle stroke="#ccc" stroke-width="10" cx="50" cy="50" r="40" fill="none" />
            <circle class="progress-ring-circle stroke-green-400" stroke-width="10" stroke-linecap="round" cx="50"
                cy="50" r="40" fill="none" stroke-dasharray="251.2" [attr.stroke-dashoffset]="progressStroke" />
        </svg>
        <div class="absolute inset-0 flex items-center justify-center text-sm font-bold">
            {{progress}}%
        </div>
    </div>
</div>
<div class="hidden md:block">
    <div class="relative w-24 h-24">
        <svg class="w-full h-full" viewBox="0 0 100 100">
            <circle stroke="#ccc" stroke-width="10" cx="50" cy="50" r="40" fill="none" />
            <circle class="progress-ring-circle stroke-green-400" stroke-width="10" stroke-linecap="round" cx="50"
                cy="50" r="40" fill="none" stroke-dasharray="251.2" [attr.stroke-dashoffset]="progressStroke" />
        </svg>
        <div class="absolute inset-0 flex items-center justify-center text-base font-bold">
            {{progress}}%
        </div>
    </div>
</div>